import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapLocationListComponent from './mapLocationList.component';

let mapLocationListModule = angular.module('mapLocationList', [
  uiRouter
])

.component('mapLocationList', mapLocationListComponent)

.name;

export default mapLocationListModule;
